import { Outlet } from "react-router-dom";

import { StudioJobsDock } from "./StudioJobsDock";
import { useStudioJobsResume } from "./useStudioJobsResume";

// Parent of every Studio page: re-attaches to generations still running for
// this user (e.g. after a reload) and shows them in a floating dock, so a run
// can be followed from anywhere in Studio.
const StudioJobsLayout = () => {
  useStudioJobsResume();
  return (
    <>
      <Outlet />
      <StudioJobsDock />
    </>
  );
};

export default StudioJobsLayout;
